import styled from 'styled-components';

export const FilterSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h4`
  margin: 0 0 16px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
`;

export const RadioSection = styled(FilterSection)`
  .MuiRadioGroup-root {
    gap: 8px;
  }

  /* Sobrescreve o estilo global do toolbar em mobile */
  @media screen and (max-width: 769px) {
    input[type="radio"] {
      width: 100% !important;
    }

    .MuiFormControlLabel-root {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`;

export const InputSection = styled(FilterSection)`
  .MuiTextField-root,
  .MuiAutocomplete-root {
    width: 100%;

    .MuiInputBase-root {
      height: 56px;
      background-color: #FFFFFF;
      border-radius: 8px;

      &:hover {
        background-color: #F9F9F9;
      }

      &.Mui-disabled {
        background-color: #F5F5F5;
      }
    }

    .MuiInputLabel-root {
      color: #666;
      font-weight: 500;
      font-size: 1rem;

      &.Mui-focused {
        color: #89BD23;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: #E0E0E0;
      border-width: 1px;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border-color: #BDBDBD;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #89BD23;
      border-width: 2px;
    }
  }

  // Específico para Autocomplete
  .MuiAutocomplete-root {
    .MuiAutocomplete-inputRoot {
      padding: 14px 12px;
      gap: 4px;
      flex-wrap: wrap;
      min-height: 56px;
      height: auto;
    }

    .MuiAutocomplete-input {
      min-width: 120px !important;
      padding: 0 !important;
    }

    .MuiAutocomplete-tag {
      margin: 2px;
      height: 28px;
    }

    .MuiAutocomplete-endAdornment {
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const CustomDateSection = styled(InputSection)`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #F0F0F0;
`;
